/*
  JHK school selector — chooser dialog and interactions (JHKCreate).

  State and first-paint rendering live inline in <head> (snippets/jhk-school-head.liquid,
  window.JHKSchool). This file adds:
  - the chooser dialog (snippets/jhk-school-dialog.liquid): loads every school from
    /collections?view=jhk-schools (all pages), caches the list for a day, filters as you type;
  - clicks on [data-jhk-school-open] (header button) and [data-jhk-school-make]
    ("Make this my school" / "Use this school" toggles);
  - a daily check that the saved school still exists (an unpublished school is dropped)
    and that its name, link, logo and colour are current;
  - syncing between tabs (storage event).
  Nothing is sent anywhere: the choice stays in the shopper's browser.
*/
(function () {
  var S = window.JHKSchool
  if (!S || window.JHKSchoolUI) return

  var LIST_KEY = 'jhk_school_list'
  var LIST_TTL = 24 * 60 * 60 * 1000
  var dialog = document.getElementById('JhkSchoolDialog')
  var settings = {}
  try { settings = JSON.parse((dialog && dialog.getAttribute('data-settings')) || '{}') } catch (e) {}

  var listPromise = null
  var schools = null

  /* ---------- data ---------- */

  function readCache() {
    try {
      var c = JSON.parse(localStorage.getItem(LIST_KEY) || 'null')
      if (c && Array.isArray(c.schools) && Date.now() - c.ts < LIST_TTL) return c.schools
    } catch (e) {}
    return null
  }
  function writeCache(list) {
    try { localStorage.setItem(LIST_KEY, JSON.stringify({ ts: Date.now(), schools: list })) } catch (e) {}
  }
  function fetchPage(n) {
    return fetch('/collections?view=jhk-schools&page=' + n, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status)
      return r.json()
    })
  }
  function loadSchools() {
    if (schools) return Promise.resolve(schools)
    var cached = readCache()
    if (cached) { schools = cached; return Promise.resolve(schools) }
    if (listPromise) return listPromise
    listPromise = fetchPage(1).then(function (first) {
      var pages = Math.max(1, Math.min(first.pages || 1, 20))
      var rest = []
      for (var p = 2; p <= pages; p++) rest.push(fetchPage(p))
      return Promise.all(rest).then(function (more) {
        var all = first.schools || []
        more.forEach(function (m) { all = all.concat(m.schools || []) })
        all = all.filter(function (s) { return s && s.h && s.t })
        all.sort(function (a, b) { return a.t.localeCompare(b.t, 'en', { sensitivity: 'base' }) })
        schools = all
        writeCache(all)
        return all
      })
    })
    listPromise.catch(function () { listPromise = null })
    return listPromise
  }

  /* ---------- search ---------- */

  function norm(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
  }
  function matches(list, query) {
    var words = norm(query).split(' ').filter(Boolean)
    if (!words.length) return list
    return list.filter(function (s) {
      var name = s._n || (s._n = ' ' + norm(s.t))
      return words.every(function (w) { return name.indexOf(w) !== -1 })
    })
  }

  /* ---------- dialog ---------- */

  var input = dialog && dialog.querySelector('#JhkSchoolSearch')
  var listEl = dialog && dialog.querySelector('#JhkSchoolList')
  var statusEl = dialog && dialog.querySelector('#JhkSchoolStatus')
  var currentEl = dialog && dialog.querySelector('[data-jhk-school-current]')

  function checkIcon() {
    return '<svg class="jhk-school-option__check" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  }

  function renderCurrent() {
    if (!currentEl) return
    var s = S.get()
    currentEl.hidden = !s
    if (!s) return
    var logoHolder = currentEl.querySelector('[data-jhk-school-current-logo]')
    logoHolder.textContent = ''
    logoHolder.appendChild(S.logo(s))
    var name = currentEl.querySelector('[data-jhk-school-current-name]')
    name.textContent = s.t
    name.title = s.t
    var shop = currentEl.querySelector('[data-jhk-school-current-shop]')
    if (shop) shop.setAttribute('href', S.url(s))
  }

  function renderList() {
    if (!listEl || !schools) return
    var found = matches(schools, input ? input.value : '')
    var saved = S.get()
    var frag = document.createDocumentFragment()
    found.forEach(function (s) {
      var li = document.createElement('li')
      var btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'jhk-school-option'
      btn.setAttribute('data-jhk-school-pick', s.h)
      if (saved && saved.h === s.h) btn.setAttribute('aria-current', 'true')
      btn.appendChild(S.logo(s))
      var name = document.createElement('span')
      name.className = 'jhk-school-option__name'
      name.textContent = s.t
      name.title = s.t
      btn.appendChild(name)
      btn.insertAdjacentHTML('beforeend', checkIcon())
      li.appendChild(btn)
      frag.appendChild(li)
    })
    listEl.textContent = ''
    listEl.appendChild(frag)
    if (statusEl) {
      var q = input ? input.value.trim() : ''
      statusEl.textContent = found.length
        ? found.length + (found.length === 1 ? ' school' : ' schools')
        : 'No school matches “' + q + '”'
    }
  }

  function renderError() {
    if (!listEl) return
    listEl.textContent = ''
    if (statusEl) statusEl.textContent = 'The school list could not be loaded.'
    var li = document.createElement('li')
    var retry = document.createElement('button')
    retry.type = 'button'
    retry.className = 'element-button element-button--size-sm jhk-school-dialog__retry'
    retry.textContent = 'Try again'
    retry.addEventListener('click', function () { openList() })
    li.appendChild(retry)
    listEl.appendChild(li)
  }

  function openList() {
    if (statusEl) statusEl.textContent = 'Loading schools…'
    return loadSchools().then(renderList, renderError)
  }

  function open() {
    if (!dialog) return
    renderCurrent()
    if (input) input.value = ''
    if (!dialog.open) {
      if (typeof dialog.showModal === 'function') dialog.showModal()
      else dialog.setAttribute('open', '')
    }
    openList()
    // Keyboard and mouse users start typing straight away; on touch screens the
    // keyboard would cover the list, so the dialog keeps its default focus.
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches
    if (input && !coarse) input.focus()
  }

  function close() {
    if (!dialog) return
    if (typeof dialog.close === 'function') dialog.close()
    else dialog.removeAttribute('open')
  }

  function pick(handle) {
    var s = null
    for (var i = 0; schools && i < schools.length; i++) if (schools[i].h === handle) s = schools[i]
    if (!s) return
    S.set({ h: s.h, t: s.t, u: s.u, l: s.l, c: s.c })
    var url = S.url(s)
    if (settings.go && location.pathname !== url) {
      location.href = url
    } else {
      close()
    }
  }

  if (dialog) {
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) return close() // backdrop
      var option = e.target.closest('[data-jhk-school-pick]')
      if (option) return pick(option.getAttribute('data-jhk-school-pick'))
      if (e.target.closest('[data-jhk-school-close]')) return close()
      if (e.target.closest('[data-jhk-school-clear]')) {
        S.clear()
        renderCurrent()
        renderList()
        if (input) input.focus()
      }
    })
    if (input) {
      input.addEventListener('input', renderList)
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var first = listEl.querySelector('[data-jhk-school-pick]')
          if (first) { e.preventDefault(); first.focus() }
        } else if (e.key === 'Enter') {
          var only = listEl.querySelectorAll('[data-jhk-school-pick]')
          if (only.length) { e.preventDefault(); pick(only[0].getAttribute('data-jhk-school-pick')) }
        }
      })
    }
    listEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return
      var items = Array.prototype.slice.call(listEl.querySelectorAll('[data-jhk-school-pick]'))
      var i = items.indexOf(document.activeElement)
      if (i === -1) return
      e.preventDefault()
      if (e.key === 'ArrowDown' && i < items.length - 1) items[i + 1].focus()
      else if (e.key === 'ArrowUp') (i > 0 ? items[i - 1] : input).focus()
    })
  }

  /* ---------- page-wide clicks ---------- */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-jhk-school-open]')
    if (opener) { e.preventDefault(); return open() }
    var make = e.target.closest('[data-jhk-school-make], [data-jhk-school="make"]')
    if (make) {
      e.preventDefault()
      if (make.getAttribute('aria-pressed') === 'true') return S.clear()
      var notice = make.closest('[data-jhk-school="notice"]')
      S.set({
        h: make.getAttribute('data-handle'),
        t: make.getAttribute('data-title'),
        u: make.getAttribute('data-url'),
        l: make.getAttribute('data-logo'),
        c: make.getAttribute('data-accent')
      })
      if (notice) confirmNotice(notice, make.getAttribute('data-title'))
    }
  })

  // The switch button sat inside the notice, which painting just hid: show a
  // confirmation in its place and keep keyboard focus there.
  function confirmNotice(notice, title) {
    var msg = notice.querySelector('[data-jhk-school-confirm]')
    if (!msg) return
    // The name truncates on narrow screens; the sentence end stays visible.
    msg.textContent = ''
    var name = document.createElement('span')
    name.className = 'jhk-school-notice__confirm-name'
    name.textContent = title
    name.title = title
    var rest = document.createElement('span')
    rest.className = 'jhk-school-notice__confirm-rest'
    rest.textContent = ' is now your school.'
    msg.appendChild(name)
    msg.appendChild(rest)
    notice.classList.add('is-confirmed')
    notice.hidden = false
    notice.setAttribute('tabindex', '-1')
    notice.focus()
  }

  // Another tab changed the school: repaint this one.
  window.addEventListener('storage', function (e) {
    if (e.key === S.key) { S.paint(); renderCurrent() }
  })

  /* ---------- daily check of the saved school ---------- */

  function validate() {
    var saved = S.get()
    if (!saved) return
    loadSchools().then(function (list) {
      var fresh = null
      for (var i = 0; i < list.length; i++) if (list[i].h === saved.h) fresh = list[i]
      if (!fresh) return S.clear() // unpublished or no longer a school
      if (fresh.t !== saved.t || fresh.u !== saved.u || fresh.l !== saved.l || fresh.c !== saved.c) {
        S.set({ h: fresh.h, t: fresh.t, u: fresh.u, l: fresh.l, c: fresh.c })
      }
    }, function () {})
  }

  S.paint()
  if (S.get()) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500) }
    idle(validate)
  }

  window.JHKSchoolUI = { open: open, close: close, load: loadSchools }
})()
